import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RORRecentActivity from "../CommonDashboard/ROR/RORRecentActivity";
import RORRushNotesSummary from "../CommonDashboard/ROR/RORRushNotesSummary";
import RORCaseActionSummary from "../CommonDashboard/ROR/RORCaseActionSummary";
import RORInvoiceOverview from "../CommonDashboard/ROR/RORInvoiceOverview";
import EditorAppointmentSummary from "../CommonDashboard/Editor/EditorAppointmentSummary";
import EditorWorkloadBreakdown from "../CommonDashboard/Editor/EditorWorkloadBreakdown";
import EditorDoctorWiseSummary from "../CommonDashboard/Editor/EditorDoctorWiseSummary";

interface EditorSummaryTypeProps {
  onTabChange: () => void;
  userRole: string;
}

const EditorSummaryType: React.FC<EditorSummaryTypeProps> = ({
  onTabChange,
  userRole,
}) => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [showRushNotesSummary, setShowRushNotesSummary] = useState(false);

  return (
    <Container fluid className="px-4 dashboard">
      <Row>
        {!showRushNotesSummary ? (
          <Col md={3} className="latestcase d-flex align-items-stretch">
            <RORRecentActivity
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              setShowRushNotesSummary={setShowRushNotesSummary}
              userRole={userRole}
            />
          </Col>
        ) : (
          <Col md={3} className="latestcase d-flex align-items-stretch">
            <RORRushNotesSummary
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              setShowRushNotesSummary={setShowRushNotesSummary}
              userRole={userRole}
            />
          </Col>
        )}
        <Col md={6} className=" caseactions d-flex align-items-stretch">
          <RORCaseActionSummary
            onTabChange={onTabChange}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            userRole={userRole}
          />
        </Col>
        <Col md={3} className="appointments d-flex align-items-stretch">
          <EditorAppointmentSummary />
        </Col>
      </Row>
      <Row className="mt-4 mb-4 case-summary align-items-stretch">
        <Col md={12}>
          <RORInvoiceOverview
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            userRole={userRole}
          />
        </Col>
      </Row>
      <Row className="mt-4 mb-4 case-summary align-items-stretch">
        <Col md={6} className="d-flex">
          <EditorWorkloadBreakdown
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
        <Col md={6} className="d-flex">
          <EditorDoctorWiseSummary
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            userRole={userRole}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default EditorSummaryType;
